import { createReducer, on } from '@ngrx/store';

import { DEFAULT_SETTINGS } from 'src/app/shared/services/appconfig/default-settings';
import { TSettings } from 'src/app/shared/services/appconfig/settings.model';

import * as settingsActions from './settings.actions';

export interface SettingsState {
  isLoaded: boolean;
  loadFailed: boolean;
  settings: Partial<TSettings>;
}

export const initialState: SettingsState = {
  isLoaded: false,
  loadFailed: false,
  settings: { ...(DEFAULT_SETTINGS as Partial<TSettings>) },
};

export const reducer = createReducer(
  initialState,
  on(settingsActions.loadSettings, (state) => ({
    ...state,
    loadFailed: false,
  })),
  on(
    settingsActions.loadSettingsSuccess,
    settingsActions.updateSettingsSuccess,
    (state, { settings }) => ({
      ...state,
      settings,
      isLoaded: true,
      loadFailed: false,
    })
  ),
  on(settingsActions.loadSettingsFailure, (state) => ({
    ...state,
    loadFailed: true,
  }))
);
